import FooterSectionImages from "./FooterSectionImages";
import CurrentNews from "./CurrentNews";
import RecentlyUpdatedFiles from "./RecentlyUpdatedFiles";

const Footer = () => {
  return (
    //<footer className="flex flex-col justify-between px-1 [@media(min-width:640px)]:!px-[48px] pt-5 pb-2.5 mt-20 w-full [@media(min-width:640px)]:flex-row">
    <footer className={`
      gap-4
      pt-5
      grid 
      grid-cols-1
      w-full 
      [@media(min-width:700px)]:!grid-cols-3 
      px-2
      [@media(min-width:700px)]:!px-[48px]
    `}>
      {/* <section className="w-full [@media(min-width:640px)]:!w-[31%]"> */}
      <section className="">
        <CurrentNews />
      </section>
      <section className="">
        <RecentlyUpdatedFiles />
      </section>
      <section className="">
        <FooterSectionImages />
      </section>
    </footer>
  );
};
export default Footer;
